export const companyInfo = {
  name: "NexSunNexova Solar Energy Private Limited",
  shortName: "NexSunNexova",
  tagline: "Powering Tomorrow with Solar, Drones &amp; EV Charging",
  regNo: "U43219TS2026PTC218422",
  gstNo: "36AALCN7952L1ZP",
  address: "#2-1-196/A, 100 Feet Road, Near Gopalpur Circle, Hanmakonda-506001, Telangana, India",
  email: "nexsun.nexova@gmail.com",
  website: "https://nexsunnexova.com",
  phones: ["8019051311", "8019041311", "9959621211", "9059621211", "9063374972"],
  founder: {
    name: "Shaik Hyder Pasha",
    role: "Founder & Managing Director",
    phone1: "9603919373",
    phone2: "7893549373",
  },
  subsidyAmount: "₹78,000",
};

export const services = [
  {
    id: "on-grid",
    title: "On-Grid Solar Installation",
    description: "Connect your solar system directly to the utility grid. Generate clean energy during the day and draw from the grid at night. Best for urban homes and businesses with stable grid access.",
    icon: "ri-flashlight-line",
    features: ["Net metering enabled", "Lowest payback period", "Grid-tie inverters", "Government subsidy eligible"],
    image: "https://readdy.ai/api/search-image?query=Modern%20residential%20rooftop%20solar%20panel%20installation%20on%20Indian%20home%20with%20clear%20sky%2C%20bright%20sunlight%2C%20clean%20professional%20photography%2C%20warm%20natural%20tones&width=800&height=600&seq=service-ongrid-01&orientation=landscape",
  },
  {
    id: "off-grid",
    title: "Off-Grid Solar Installation",
    description: "Complete energy independence with battery storage. Perfect for remote locations, farms, and areas with unreliable grid power. Store excess energy for nighttime use.",
    icon: "ri-battery-2-charge-line",
    features: ["Battery backup included", "No electricity bills", "Ideal for rural areas", "24/7 power availability"],
    image: "https://readdy.ai/api/search-image?query=Off-grid%20solar%20panel%20system%20with%20battery%20storage%20in%20rural%20Indian%20farm%20setting%2C%20green%20fields%2C%20warm%20golden%20hour%20lighting%2C%20professional%20photography&width=800&height=600&seq=service-offgrid-01&orientation=landscape",
  },
  {
    id: "commercial",
    title: "Commercial & Industrial Solar",
    description: "Large-scale solar solutions for factories, warehouses, schools, and commercial buildings. Reduce operational costs significantly with custom-designed solar power plants.",
    icon: "ri-building-4-line",
    features: ["Custom capacity design", "Rooftop & ground mount", "Power purchase agreements", "Rapid ROI"],
    image: "https://readdy.ai/api/search-image?query=Large%20commercial%20solar%20panel%20installation%20on%20industrial%20factory%20roof%20in%20India%2C%20rows%20of%20blue%20panels%2C%20clear%20sky%2C%20professional%20aerial%20photography%2C%20bright%20daylight&width=800&height=600&seq=service-commercial-01&orientation=landscape",
  },
  {
    id: "ev-charging",
    title: "EV Charging Station Installation",
    description: "End-to-end EV charging infrastructure for homes, apartments, offices, and commercial spaces. From 3.3 kW home chargers to 60 kW DC fast chargers — we supply, install, and maintain.",
    icon: "ri-charging-pile-line",
    features: ["AC & DC fast chargers", "Home & commercial setups", "OCPP smart management", "Subsidy eligible"],
    image: "https://readdy.ai/api/search-image?query=Modern%20EV%20electric%20vehicle%20charging%20station%20in%20clean%20parking%20area%2C%20sleek%20charger%20unit%20with%20glowing%20LED%20display%2C%20white%20electric%20car%20plugged%20in%2C%20professional%20product%20photography%2C%20bright%20clean%20lighting&width=800&height=600&seq=service-ev-01&orientation=landscape",
  },
  {
    id: "drone-spray",
    title: "Agricultural Spray Drone Services",
    description: "Precision crop spraying with advanced agricultural drones. Cover 5 acres in 30 minutes with targeted liquid fertilizer and pesticide application. Reduce chemical use by 30%.",
    icon: "ri-flight-takeoff-line",
    features: ["5 acres in 30 min", "30% less chemical use", "Liquid & mist spraying", "Telangana-wide service"],
    image: "https://readdy.ai/api/search-image?query=Agricultural%20drone%20spraying%20liquid%20fertilizer%20over%20lush%20green%20paddy%20field%20in%20India%2C%20visible%20mist%20droplets%20in%20golden%20sunlight%2C%20professional%20photography%2C%20high%20detail&width=800&height=600&seq=service-drone-01&orientation=landscape",
  },
  {
    id: "water-pump",
    title: "Solar Water Pump Installation",
    description: "Irrigate your fields with zero fuel cost. Our solar-powered water pumps are designed for agricultural use, from small farms to large plantations.",
    icon: "ri-water-flash-line",
    features: ["1 HP to 15 HP range", "No diesel cost", "Low maintenance", "Submersible & surface pumps"],
    image: "https://readdy.ai/api/search-image?query=Solar%20powered%20water%20pump%20in%20agricultural%20field%20in%20India%2C%20water%20flowing%20from%20pipe%2C%20green%20crops%2C%20solar%20panels%20nearby%2C%20warm%20natural%20light%2C%20professional%20photography&width=800&height=600&seq=service-pump-01&orientation=landscape",
  },
  {
    id: "fencing",
    title: "Solar Fencing Systems",
    description: "Protect your farmland with electric fencing powered entirely by solar energy. Humane, effective, and maintenance-free perimeter security for agricultural properties.",
    icon: "ri-shield-check-line",
    features: ["Animal intrusion protection", "Low voltage safe design", "All-weather operation", "Easy installation"],
    image: "https://readdy.ai/api/search-image?query=Solar%20powered%20electric%20fence%20around%20agricultural%20farm%20in%20India%2C%20green%20fields%2C%20solar%20panel%20near%20fence%2C%20warm%20daylight%2C%20professional%20photography&width=800&height=600&seq=service-fencing-01&orientation=landscape",
  },
];

export const products = [
  {
    id: "epc-on-grid",
    category: "EPC On-Grid (With Installation)",
    description: "Complete turnkey solar system with professional installation. Includes panels, inverters, mounting, cabling, and commissioning.",
    items: [
      { name: "3-6 kW (1P)", price: "₹66,000/kW", note: "" },
      { name: "7-9 kW", price: "₹61,000/kW", note: "" },
      { name: "10-20 kW", price: "₹56,000/kW", note: "" },
      { name: "21-50 kW", price: "₹54,000/kW", note: "" },
      { name: "51-100 kW", price: "₹52,000/kW", note: "" },
      { name: "101-150 kW", price: "₹50,000/kW", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Professional%20solar%20panel%20installation%20on%20Indian%20residential%20rooftop%2C%20worker%20installing%20panels%2C%20safety%20gear%2C%20clean%20bright%20daylight%2C%20professional%20photography&width=600&height=400&seq=product-epc-01&orientation=landscape",
    badge: "Most Popular",
  },
  {
    id: "ev-chargers",
    category: "EV Charging Stations",
    description: "AC and DC fast chargers for homes, apartments, offices, and commercial spaces. Includes installation, OCPP software, and AMC support.",
    items: [
      { name: "3.3 kW AC Home (incl. GST)", price: "₹19,150", note: "" },
      { name: "7.4 kW AC Wallbox (incl. GST)", price: "₹40,505", note: "" },
      { name: "12 kW DC Fast (incl. GST)", price: "₹3,30,500", note: "" },
      { name: "60 kW DC Fast (incl. GST)", price: "₹11,31,140", note: "" },
      { name: "120 kW DC Fast (incl. GST)", price: "₹16,48,440", note: "" },
      { name: "180 kW DC Fast (incl. GST)", price: "₹19,46,640", note: "" },
      { name: "240 kW DC Fast (incl. GST)", price: "₹22,56,090", note: "" },
      { name: "360 kW DC Fast (incl. GST)", price: "₹35,42,340", note: "" },
      { name: "480 kW DC Fast (incl. GST)", price: "₹39,91,740", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Modern%20EV%20charging%20station%20unit%20in%20sleek%20parking%20lot%2C%20multiple%20charger%20posts%20with%20LED%20status%20indicators%2C%20electric%20car%20nearby%2C%20clean%20professional%20product%20photography%2C%20bright%20daylight%2C%20high%20tech%20futuristic%20design&width=600&height=400&seq=product-ev-01&orientation=landscape",
    badge: "New Arrival",
  },
  {
    id: "drone-spray",
    category: "Agricultural Spray Drones",
    description: "Professional agricultural drones for precision liquid spraying. Includes training, spare parts, and AMC packages.",
    items: [
      { name: "10L Spray Drone (Basic)", price: "₹1,85,000", note: "" },
      { name: "16L Spray Drone (Pro)", price: "₹2,45,000", note: "" },
      { name: "20L Spray Drone (Heavy)", price: "₹3,15,000", note: "" },
      { name: "Spare Battery Pack", price: "₹28,500", note: "" },
      { name: "Spray Nozzle Set", price: "₹4,200", note: "" },
      { name: "Drone AMC (1 Year)", price: "₹35,000", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Professional%20agricultural%20spray%20drone%20on%20ground%20in%20green%20paddy%20field%2C%20folded%20arms%2C%20orange%20and%20black%20design%2C%20spraying%20tank%20visible%2C%20morning%20golden%20light%2C%20professional%20product%20photography%2C%20high%20detail&width=600&height=400&seq=product-drone-01&orientation=landscape",
    badge: "Farmer's Choice",
  },
  {
    id: "diy-on-grid",
    category: "DIY On-Grid Kits",
    description: "Self-install solar kits for tech-savvy homeowners and electricians. Includes all components with detailed installation guide.",
    items: [
      { name: "0.5 kW", price: "₹58,000", note: "" },
      { name: "1 kW", price: "₹88,000", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Solar%20panel%20DIY%20kit%20components%20neatly%20arranged%20on%20white%20background%2C%20inverter%2C%20panels%2C%20cables%2C%20mounting%20brackets%2C%20clean%20product%20photography%2C%20warm%20natural%20light&width=600&height=400&seq=product-diy-01&orientation=landscape",
    badge: "Budget Friendly",
  },
  {
    id: "solar-pumps",
    category: "Solar Water Pumps",
    description: "Agricultural solar pumps ranging from 1 HP to 15 HP. Perfect for irrigation with zero fuel costs.",
    items: [
      { name: "1 HP", price: "₹74,600", note: "" },
      { name: "2 HP", price: "₹1,16,848", note: "" },
      { name: "3 HP", price: "₹1,55,464", note: "" },
      { name: "5 HP", price: "₹2,24,809", note: "" },
      { name: "7.5 HP", price: "₹3,28,318", note: "" },
      { name: "10 HP", price: "₹4,17,358", note: "" },
      { name: "15 HP", price: "₹6,17,698", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Solar%20powered%20agricultural%20water%20pump%20system%20in%20green%20farm%20field%20India%2C%20water%20spraying%20on%20crops%2C%20solar%20panel%20array%2C%20warm%20daylight%2C%20professional%20photography&width=600&height=400&seq=product-pump-01&orientation=landscape",
    badge: "Farmer's Choice",
  },
  {
    id: "solar-batteries",
    category: "Solar Batteries",
    description: "Deep-cycle solar batteries designed for long life and reliable backup power in off-grid and hybrid systems.",
    items: [
      { name: "100 Ah", price: "₹21,550", note: "" },
      { name: "150 Ah", price: "₹23,750", note: "" },
      { name: "180 Ah", price: "₹26,764", note: "" },
      { name: "200 Ah", price: "₹27,808", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Deep%20cycle%20solar%20battery%20bank%20in%20clean%20modern%20energy%20storage%20room%2C%20organized%20battery%20setup%2C%20subtle%20green%20LED%20indicators%2C%20professional%20product%20photography%2C%20warm%20lighting&width=600&height=400&seq=product-battery-01&orientation=landscape",
    badge: "",
  },
  {
    id: "solar-inverters",
    category: "Solar Inverters",
    description: "High-efficiency string and hybrid inverters from leading brands. Convert DC solar power to AC for your home or business.",
    items: [
      { name: "1 kW String Inverter", price: "₹18,500", note: "" },
      { name: "3 kW String Inverter", price: "₹32,000", note: "" },
      { name: "5 kW Hybrid Inverter", price: "₹48,500", note: "" },
      { name: "10 kW Three-Phase", price: "₹85,000", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Modern%20solar%20inverter%20device%20mounted%20on%20wall%20in%20clean%20utility%20room%2C%20LED%20display%20showing%20power%20output%2C%20professional%20product%20photography%2C%20warm%20neutral%20background&width=600&height=400&seq=product-inverter-01&orientation=landscape",
    badge: "",
  },
  {
    id: "street-lights",
    category: "Solar Street Lights",
    description: "Energy-efficient solar street lighting solutions for roads, campuses, parking lots, and public spaces.",
    items: [
      { name: "12W Solar Street Light", price: "₹4,850", note: "" },
      { name: "24W Solar Street Light", price: "₹7,200", note: "" },
      { name: "40W Solar Street Light", price: "₹11,500", note: "" },
      { name: "60W Solar Street Light", price: "₹16,800", note: "" },
    ],
    image: "https://readdy.ai/api/search-image?query=Solar%20street%20light%20along%20modern%20Indian%20road%20at%20dusk%2C%20warm%20glow%20from%20LED%20light%2C%20solar%20panel%20on%20top%2C%20clean%20urban%20setting%2C%20professional%20photography&width=600&height=400&seq=product-streetlight-01&orientation=landscape",
    badge: "",
  },
];

export const productRange = [
  { name: "Solar Inverters", icon: "ri-flashlight-line" },
  { name: "Solar Street Lights", icon: "ri-lightbulb-flash-line" },
  { name: "Solar Water Heaters", icon: "ri-drop-line" },
  { name: "Solar Water Pumps", icon: "ri-water-flash-line" },
  { name: "Solar Fencing Systems", icon: "ri-shield-check-line" },
  { name: "Solar Dryers", icon: "ri-sun-line" },
  { name: "Solar Cables & Mounting", icon: "ri-tools-line" },
  { name: "Rock Lights & Accessories", icon: "ri-flashlight-line" },
  { name: "Agriculture Spray Drones", icon: "ri-plane-line" },
  { name: "EV Charging Stations", icon: "ri-charging-pile-line" },
];

export const stats = [
  { value: "₹78,000", label: "Government Subsidy Available", suffix: "" },
  { value: "150", label: "kW Max EPC Capacity", suffix: "+" },
  { value: "3", label: "Pillars: Solar · Drone · EV", suffix: "" },
  { value: "25", label: "Years Panel Warranty", suffix: "+" },
];

export const testimonials = [
  {
    name: "Ramesh Kumar",
    role: "Homeowner, Warangal",
    text: "NexSunNexova installed a 5kW on-grid system at our home. The entire process was smooth — from site survey to subsidy paperwork to installation. Our electricity bill dropped by 85%!",
    rating: 5,
  },
  {
    name: "Srinivas Reddy",
    role: "Farm Owner, Karimnagar",
    text: "The 7.5 HP solar water pump has completely transformed our farm irrigation. No more diesel costs, and the pump works flawlessly even during peak summer. Highly recommended for every farmer.",
    rating: 5,
  },
  {
    name: "Priya Sharma",
    role: "Factory Manager, Hyderabad",
    text: "We installed a 50kW commercial solar plant for our manufacturing unit. ROI was achieved in under 4 years. The team's professionalism and after-sales support is excellent.",
    rating: 5,
  },
  {
    name: "Mohammed Ali",
    role: "School Principal, Hanmakonda",
    text: "The solar street lights installed across our school campus have significantly improved safety and reduced our electricity expenses. Quality products at fair prices.",
    rating: 4,
  },
];

export const whyChooseUs = [
  {
    title: "Transparent Pricing",
    description: "No hidden charges. All costs disclosed upfront with detailed quotations. EPC pricing includes installation unless stated otherwise.",
    icon: "ri-price-tag-3-line",
  },
  {
    title: "Government Subsidy Assistance",
    description: "We handle all paperwork for PM Surya Ghar and state subsidies. Get up to ₹78,000 in government benefits with zero hassle.",
    icon: "ri-government-line",
  },
  {
    title: "End-to-End Solutions",
    description: "From site assessment and system design to installation, commissioning, and AMC — we manage everything so you don't have to.",
    icon: "ri-stack-line",
  },
  {
    title: "Quality Products",
    description: "We partner with tier-1 solar panel manufacturers and use certified inverters, batteries, and mounting structures only.",
    icon: "ri-shield-star-line",
  },
  {
    title: "Expert Team",
    description: "Our certified engineers and technicians have years of experience in solar installations across residential, commercial, and agricultural projects.",
    icon: "ri-team-line",
  },
  {
    title: "After-Sales Support",
    description: "Comprehensive AMC packages, remote monitoring, and quick service response. Your solar investment is protected for the long term.",
    icon: "ri-customer-service-2-line",
  },
];

export const serviceAreas = [
  "Hanmakonda",
  "Warangal",
  "Karimnagar",
  "Hyderabad",
  "Khammam",
  "Nizamabad",
  "Mahbubnagar",
  "Adilabad",
  "Nalgonda",
  "Medak",
];

export const contactFormFields = {
  serviceTypes: [
    "On-Grid Solar Installation",
    "Off-Grid Solar Installation",
    "Commercial Solar Project",
    "Residential Rooftop Solar",
    "Solar Water Pump",
    "Solar Fencing",
    "Solar Street Lights",
    "Solar Batteries",
    "EV Charging Station",
    "Other",
  ],
  capacityOptions: [
    "Below 3 kW",
    "3-6 kW",
    "7-10 kW",
    "11-20 kW",
    "21-50 kW",
    "51-100 kW",
    "100+ kW",
    "Not Sure - Need Consultation",
  ],
};